export const messages = {
  en: {
    groupBuyBatchManage: {
      searchConditions: 'Search Conditions',
      groupBuyBatch: 'Group Buy Batch',
      groupBuyName: 'Group Buy Name',
      batchId: 'Batch ID',
      settingId: 'Setting ID',
      search: 'Search',
      reset: 'Reset',
      batchStartTime: 'Start Time',
      batchEndTime: 'End Time',
      curBatch: 'Current Batch',
      createTime: 'Create Time',
      operations: 'Operations',
      groupBuyList: 'Group Buy List'
    }
  },
  zh: {
    groupBuyBatchManage: {
      searchConditions: '查询条件',
      groupBuyBatch: '拼团批次',
      groupBuyName: '拼团名称',
      batchId: '批次编号',
      settingId: '团购设置ID',
      search: '查询',
      reset: '重置',
      batchStartTime: '开始时间',
      batchEndTime: '结束时间',
      curBatch: '当前批次',
      createTime: '创建时间',
      operations: '操作',
      groupBuyList: '拼团列表'
    }
  }
}